module.exports = __webpack_public_path__ + "img/dictor.148e5c36.svg";